import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

function Banner() {
  const pages = [
    {
      btn_text: "Explore Biotechnology",
      title: "Biotechnology",
      heading: "Ask an Expert in Biotechnology",
      per: "Get expert insights on innovations in biotechnology, from genetic engineering and cloning to medical applications and industrial processes."
    },
    {
      btn_text: "Discover Genetics",
      title: "Genetics",
      heading: "Ask an Expert in Genetics",
      per: "Understand the science of heredity, DNA, and gene functions with guidance from genetics experts."
    },
    {
      btn_text: "Learn Molecular Biology",
      title: "Molecular Biology",
      heading: "Ask an Expert in Molecular Biology",
      per: "Explore the molecular mechanisms of life, including DNA replication, transcription, translation, and gene regulation."
    },
    {
      btn_text: "Unlock Biochemistry",
      title: "Biochemistry",
      heading: "Ask an Expert in Biochemistry",
      per: "Gain knowledge about chemical processes in living organisms, including enzymes, metabolism, and biomolecules."
    },
    {
      btn_text: "Explore Ecology",
      title: "Ecology",
      heading: "Ask an Expert in Ecology",
      per: "Learn about ecosystems, biodiversity, and the interactions between organisms and their environment."
    },
    {
      btn_text: "Discover Zoology",
      title: "Zoology",
      heading: "Ask an Expert in Zoology",
      per: "Discover the study of animals, their physiology, behavior, and role in the natural world."
    },
    {
      btn_text: "Learn Botany",
      title: "Botany",
      heading: "Ask an Expert in Botany",
      per: "Get expert guidance on plant biology, growth, classification, and ecological importance."
    },
    {
      btn_text: "Explore Microbiology",
      title: "Microbiology",
      heading: "Ask an Expert in Microbiology",
      per: "Understand microorganisms, their roles in health, disease, industry, and environmental processes."
    },
    {
      btn_text: "Ask Biology Expert",
      title: "Biology",
      heading: "Ask an Expert in Biology",
      per: "Connect with experts to explore the science of life, covering all living organisms and biological systems."
    }
  ]
  const [data, setData] = useState({})
  const parms = useParams()
  useEffect(() => {
    const filterData = pages.find((item) => item.title?.toLowerCase() === parms.slug.replace(/-/g, " "))
    setData(filterData)
    // eslint-disable-next-line
  }, [parms?.slug])
  return (
    <div className='banner_an_expert'>
      <div className='container'>
        <div className='text-banner'>
          <h1>Ask An Expert in <span>{parms?.slug}</span></h1>
          <p>{data?.per}</p>
          {/* <button>{data?.btn_text}</button> */}
        </div>
      </div>

    </div>
  )
}

export default Banner